export default {
  ask: 'ASK_MANUAL_ASK',
  reset: 'ASK_MANUAL_RESET',
  setCategory: 'ASK_MANUAL_SET_CATEGORY',
  feedback: 'ASK_MANUAL_FEEDBACK',
};
